export const PASSWORD_LOGIN_DISABLED_HEADER = "パスワードログインを無効にする";
export const PASSWORD_LOGIN_DISABLE = "する";
export const PASSWORD_LOGIN_ALLOW = "しない";

export const PASSWORD_LOGIN_LOCKOUT_MESSAGE =
  "パスワードログインを無効にする場合は、GoogleアカウントまたはMicrosoftアカウントを入力してください。";

export type PasswordLoginIntent =
  | { kind: "keep" }
  | { kind: "set"; disabled: boolean };

export function formatPasswordLoginDisabledCell(disabled: boolean): string {
  return disabled ? PASSWORD_LOGIN_DISABLE : PASSWORD_LOGIN_ALLOW;
}

export function readPasswordLoginCell(
  raw: string | undefined,
  blank: "keep" | "allow"
): { ok: true; intent: PasswordLoginIntent } | { ok: false; raw: string } {
  const value = raw?.trim() ?? "";
  if (value === "") {
    return blank === "keep"
      ? { ok: true, intent: { kind: "keep" } }
      : { ok: true, intent: { kind: "set", disabled: false } };
  }
  if (value === PASSWORD_LOGIN_DISABLE) {
    return { ok: true, intent: { kind: "set", disabled: true } };
  }
  if (value === PASSWORD_LOGIN_ALLOW) {
    return { ok: true, intent: { kind: "set", disabled: false } };
  }
  return { ok: false, raw: value };
}

export type StaffAddCsvLayout =
  | { kind: "legacy"; classroomStartIndex: 5 }
  | { kind: "withFlag"; classroomStartIndex: 6; flagIndex: 5 };

export function detectStaffAddCsvLayout(header: string[]): StaffAddCsvLayout {
  const cells = header.map(cell => String(cell ?? "").trim());
  if (cells.length === 6) {
    return { kind: "legacy", classroomStartIndex: 5 };
  }
  if (cells.length === 7 && cells[5] === PASSWORD_LOGIN_DISABLED_HEADER) {
    return { kind: "withFlag", classroomStartIndex: 6, flagIndex: 5 };
  }
  throw new Error("CSVフォーマットが正しくありません。");
}
